import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/constants";

// Bordered card with a tinted indigo header strip and numbered rows —
// the widget pattern a product dashboard uses for a ranked list.
export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="panel overflow-hidden sticky top-24">
            <div className="flex items-center gap-2.5 px-5 py-3.5 bg-accent-soft border-b border-line">
                <Flame size={15} className="text-accent" />
                <h4 className="eyebrow text-accent">Trending Now</h4>
            </div>
            <ol className="divide-y divide-line">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-3.5 px-5 py-4 hover:bg-surface-raised transition-colors duration-150"
                        >
                            <span className="grid place-items-center w-6 h-6 shrink-0 rounded-md border border-line bg-surface-raised font-mono text-[11px] font-medium text-dim tabular-nums group-hover:border-accent/40 group-hover:bg-accent-soft group-hover:text-accent transition-colors duration-150">
                                {i + 1}
                            </span>
                            <div className="min-w-0">
                                <h5 className="font-display text-sm font-semibold leading-snug text-foreground group-hover:text-accent transition-colors duration-150">
                                    {a.title}
                                </h5>
                                <span className="block mt-1 text-[11px] font-medium text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="px-5 py-6 text-sm text-dim">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
